import type { CSSProperties } from 'react';
import FilledCaretRightIconSvg from '../../assets/icons/filled_caret_right.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const FilledCaretRightIcon: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <FilledCaretRightIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default FilledCaretRightIcon;
